<script>
    import { _sendPasswordResetEmail } from "../../firebase/auth";
    import AuthError from "../../components/auth/AuthError.svelte";
    import { navigate } from "svelte-routing";
    import ButtonPrimary from "../../components/ButtonPrimary.svelte";
    import Input from "../../components/Input.svelte";

    let errorCode;
    let email;

    function sendPasswordResetEmail () {
        _sendPasswordResetEmail(email)
        .then(() => {
            email= undefined;
            navigate("/passwort/reset-email-versandt");
        })
        .catch((error) => {
            errorCode = error.code;
        });
    }

    function validate () {
        if (!email) {
            return;
        }
        else {
            sendPasswordResetEmail();
        }
    }
</script>

<div class="form">
    <h1>Passwort vergessen</h1>
    <form on:submit|preventDefault={validate}>
        <Input type="email" label="E-Mail" bind:value={email}></Input>
        <div class="actions">
            <ButtonPrimary type="submit">Passwort zurücksetzen</ButtonPrimary>
        </div>
    </form>
    <AuthError errorCode={errorCode}/>
</div>

<style>
    .form {
        max-width: 30rem;
        margin: auto;
    }

    .actions {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
        margin-top: 2rem;
    }
</style>